export const tierOneLimit = 3;
export const tierTwoLimit = 6;
export const tieroOnePrice = 15;
export const tierTwoPrice = 10;
export const tierThreePrice = 7;
